import type { VChartSpecPipeline } from 'src/types'
import {
  initLine,
  backgroundColor,
  label,
  tooltip,
  discreteLegend,
  color,
  lineStyle,
  annotationVerticalLine,
  annotationHorizontalLine,
  verticalCrosshairLine,
  progressive,
  colorAdapter,
  linearColor,
  colorLegend,
  brush,
  xBand,
  yLinear,
  colorLineStyleFill,
  annotationArea,
  splitLine,
  playerLine,
  annotationPoint,
  datasetXY,
  isPlayer,
  fontFamilyTheme,
} from '../pipes'

const raceLine: VChartSpecPipeline = [
  fontFamilyTheme,
  initLine,
  colorAdapter(color, linearColor),
  backgroundColor,
  isPlayer(playerLine, datasetXY),
  progressive,
  xBand,
  yLinear,
  brush,
  verticalCrosshairLine,
  colorAdapter(discreteLegend, colorLegend),
  colorLineStyleFill(lineStyle),
  label,
  tooltip({ titleEncoding: 'x' }),
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
  splitLine,
]

export const raceLineSpecPipeline = raceLine
